import React from 'react';
import PurchaseOrderList from '../../../../../pages/purchases/list/PurchaseOrderList';

const PurchaseOrderInJob = ({ jobId }: { jobId: string }) => {
  return <PurchaseOrderList independent={false} extraAdvancedFilter={`PurchaseOrderItem_id_orderId.jobId:${jobId}`} />;
};

export default PurchaseOrderInJob;
